import React from "react";
import CommissaryLayout from "../../layout/CommissaryLayout";
import { Tabs } from "antd";
import RawCategory from "./raw-category/RawCategory";
import ProductCategory from "./product-category/ProductCategory";

const CommissaryCategory = () => {
  const items = [
    {
      key: "1",
      label: `Raw Category`,
      children: <RawCategory />,
    },
    {
      key: "2",
      label: `Product Category`,
      children: <ProductCategory />,
    },
  ];

  //   const onChange = (key) => {
  //     console.log(key);
  //   };

  return (
    <CommissaryLayout>
      <Tabs
        defaultActiveKey="1"
        items={items}
        //   onChange={onChange}
      />
    </CommissaryLayout>
  );
};

export default CommissaryCategory;
